import AbstractStorage from './abstract-storage';
import CookieStorage from './cookie-storage';

module.exports = () => {
  let storageClass = AbstractStorage;
  let hasGlobalStorage = true;

  // Check if global storage is available
  try {
    if (window.localStorage) {
      // Necessary check for Safari iOS who throws error on localStorage.setItem() when in private browsing mode
      window.localStorage.setItem('test', ' ');
      window.localStorage.removeItem('test');
    } else {
      hasGlobalStorage = false;
    }
  } catch (error) {
    hasGlobalStorage = false;
  }

  if (!hasGlobalStorage) {
    storageClass = CookieStorage;
  }

  class LocalStorage extends storageClass {
    name() {
      return 'localStorage';
    }
  }

  return class LocalStorageProvider {
    static $get = ['$cookies', '$window', ($cookies, $window) => {
      if (hasGlobalStorage) {
        return new LocalStorage($window);
      }
      return new LocalStorage($cookies, $window);
    }];
  };
};



// WEBPACK FOOTER //
// ./main/providers/local-storage.js